module.exports = __webpack_public_path__ + "img/kearneylogo.bd0d3307.png";